<template>
    <li class="export-option p-2 ml-5 mr-5">
        <div class="d-flex flex-wrap align-items-center ps-2-max ul-dark-grey">
            {{optionContent.displayText}}
            <i class="fa fa-info-circle ul-tooltip" data-toggle="tooltip" data-placement="top" v-bind:title="optionContent.toolTipText"></i>
            <div class="option-content-div flex-grow-1 pl-5-max">
                <select v-model="optionContent.selectedValue" class="form-control form-control-sm rounded-0 export-setting-entry">
                    <option v-for="(selection, index) in optionContent.options" v-bind:key="index" v-bind:value="selection.value" v-bind:selected="selection.selected">{{selection.text}}</option>
                </select>
            </div>
        </div>
    </li>
</template>

<script>
    import $ from 'jquery';

    export default {
        name: 'ExportOptionSelection',
        props: {
            optionContent: {
                type: Object,
                default: () => {
                    return {
                        optionId: "",
                        name: "",
                        displayText: "",
                        toolTipText: "",
                        displayTypeId: "",
                        options: [],
                        selectedValue: ""
                    }
                }
            }
        },
        methods: {
            selected(index) {
                return index === 0;
            }
        },
        mounted() {
            $('.ul-tooltip').tooltip();
        }
    }
</script>

<style scoped>
    @media (max-width: 1299.9px) {
        .option-content-div {
            width: 100%;
        }
    }

    @media (min-width: 1300px) {
        .pl-5-max {
            padding-left: 3rem !important;
        }
        .ps-2-max {
            padding-left: 0.5rem !important;
            padding-right: 0.5rem !important;
        }
    }

    @media (max-width: 434.9px ) {
        i.fa {
            font-size: 200%;
        }
    }
</style>